(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-compare-toggle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGComparisonToggle extends HTMLElement {
      constructor() {
        super();
        this.items = null;
      }

      connectedCallback() {
        this.items = this.querySelectorAll('.yg-comparison-toggle-item');
        this.init();
        this.bindEvents();
      }

      init() {
        if (!this.items || this.items.length === 0) {
          return;
        }

        // 获取所有相关的sections
        const allSections = this.getAllSections();

        // 设置第一个item为active，对应的section显示，其他隐藏
        const firstItem = this.items[0];
        const firstIndex = this.getItemIndex(firstItem);

        if (firstIndex) {
          // 设置第一个item为active
          this.setActiveItem(firstItem);

          // 显示第一个对应的section，隐藏其他
          this.showSection(firstIndex, allSections);
        }
      }

      bindEvents() {
        if (!this.items || this.items.length === 0) {
          return;
        }

        this.items.forEach((item) => {
          item.addEventListener('click', (e) => {
            this.handleItemClick(e, item);
          });
        });
      }

      handleItemClick(event, item) {
        const index = this.getItemIndex(item);
        if (!index) {
          return;
        }

        // 更新active状态
        this.setActiveItem(item);

        // 获取所有相关的sections
        const allSections = this.getAllSections();

        // 显示对应的section，隐藏其他
        this.showSection(index, allSections);
      }

      getItemIndex(item) {
        return item.getAttribute('data-index');
      }

      getAllSections() {
        const indices = Array.from(this.items)
          .map((item) => this.getItemIndex(item))
          .filter((index) => index !== null);

        const selector = indices.map((index) => `.section[data-section-index="${index}"]`).join(', ');
        return document.querySelectorAll(selector);
      }

      findTargetSection(index) {
        const selector = `.section[data-section-index="${index}"]`;
        return document.querySelector(selector);
      }

      setActiveItem(activeItem) {
        // 移除所有item的active类名
        this.items.forEach((item) => {
          item.classList.remove('active');
        });

        // 添加当前item的active类名
        if (activeItem) {
          activeItem.classList.add('active');
        }
      }

      showSection(targetIndex, allSections) {
        const targetSection = this.findTargetSection(targetIndex);

        // 隐藏所有sections
        allSections.forEach((section) => {
          section.classList.add('hide');
        });

        // 显示目标section
        if (targetSection) {
          targetSection.classList.remove('hide');
        }
      }
    }

    if (!customElements.get('yg-comparison-toggle')) {
      customElements.define('yg-comparison-toggle', YGComparisonToggle);
    }

    if (!window.ygCompareQuizPromptBound) {
      window.ygCompareQuizPromptBound = true;

      document.addEventListener(
        'click',
        (event) => {
          const trigger = event.target instanceof Element ? event.target.closest('[data-yg-quiz-open]') : null;

          if (!trigger) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          const targetId = trigger.dataset.ygQuizTarget || trigger.getAttribute('aria-controls') || '';
          let drawer = targetId ? document.getElementById(targetId) : null;

          if (!drawer) {
            drawer = document.querySelector('[data-yg-quiz-drawer]');
          }

          if (drawer?.id && !trigger.hasAttribute('aria-controls')) {
            trigger.setAttribute('aria-controls', drawer.id);
          }

          if (drawer?.show) {
            window.YgQuizPatchDrawer?.(drawer);
            drawer.show();
            return;
          }

          document.dispatchEvent(
            new CustomEvent('yg-quiz:open', {
              detail: { id: drawer?.id || targetId },
            })
          );
        },
        true
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-comparison-toggle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGComparisonToggle extends HTMLElement {
      constructor() {
        super();
        this.items = null;
      }

      connectedCallback() {
        this.items = this.querySelectorAll('.yg-comparison-toggle-item');
        this.init();
        this.bindEvents();
      }

      init() {
        if (!this.items || this.items.length === 0) {
          return;
        }

        // 获取所有相关的sections
        const allSections = this.getAllSections();

        // 设置第一个item为active，对应的section显示，其他隐藏
        const firstItem = this.items[0];
        const firstIndex = this.getItemIndex(firstItem);

        if (firstIndex) {
          // 设置第一个item为active
          this.setActiveItem(firstItem);

          // 显示第一个对应的section，隐藏其他
          this.showSection(firstIndex, allSections);
        }
      }

      bindEvents() {
        if (!this.items || this.items.length === 0) {
          return;
        }

        this.items.forEach((item) => {
          item.addEventListener('click', (e) => {
            this.handleItemClick(e, item);
          });
        });
      }

      handleItemClick(event, item) {
        const index = this.getItemIndex(item);
        if (!index) {
          return;
        }

        // 更新active状态
        this.setActiveItem(item);

        // 获取所有相关的sections
        const allSections = this.getAllSections();

        // 显示对应的section，隐藏其他
        this.showSection(index, allSections);
      }

      getItemIndex(item) {
        return item.getAttribute('data-index');
      }

      getAllSections() {
        const indices = Array.from(this.items)
          .map((item) => this.getItemIndex(item))
          .filter((index) => index !== null);

        const selector = indices.map((index) => `.section[data-section-index="${index}"]`).join(', ');
        return document.querySelectorAll(selector);
      }

      findTargetSection(index) {
        const selector = `.section[data-section-index="${index}"]`;
        return document.querySelector(selector);
      }

      setActiveItem(activeItem) {
        // 移除所有item的active类名
        this.items.forEach((item) => {
          item.classList.remove('active');
        });

        // 添加当前item的active类名
        if (activeItem) {
          activeItem.classList.add('active');
        }
      }

      showSection(targetIndex, allSections) {
        const targetSection = this.findTargetSection(targetIndex);

        // 隐藏所有sections
        allSections.forEach((section) => {
          section.classList.add('hide');
        });

        // 显示目标section
        if (targetSection) {
          targetSection.classList.remove('hide');
        }
      }
    }

    customElements.define('yg-comparison-toggle', YGComparisonToggle);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-show-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGProductShowTab extends HTMLElement {
      constructor() {
        super();
        this.tabBoxes = [];
        this.currentIndex = 0;
        this.activeColorIndex = 1;
      }

      connectedCallback() {
        this.tabBoxes = this.querySelectorAll('.yg-tab-box');
        this.tabTexts = this.querySelectorAll('.yg-tab-text');
        this.colorIcon = this.querySelector('.yg-color-tab-box .yg-tab-icon');
        this.colorItems = this.querySelectorAll('.yg-color-item');
        this.tabImages = this.querySelectorAll('.yg-tab-image');
        this.colorImages = this.querySelector('.yg-color-tab-box .yg-tab-image');

        this.tabButtons = this.querySelector('.yg-tab-buttons');
        this.prevButton = this.querySelector('.yg-prev');
        this.nextButton = this.querySelector('.yg-next');
        this.crossButton = this.querySelector('.yg-cross');

        this.initColorTab();
        this.initMeasurements();
        this.init();
        this.initNavigation();
        this.initCloseButton();
      }

      init() {
        // 为每个tab绑定点击事件
        this.tabBoxes.forEach((tabBox, index) => {
          tabBox.addEventListener('click', () => this.selectTab(index));
        });
      }

      initNavigation() {
        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.previousTab());
          this.nextButton.addEventListener('click', () => this.nextTab());
        }
      }

      // 新增关闭按钮初始化方法
      initCloseButton() {
        if (this.crossButton) {
          this.crossButton.addEventListener('click', () => this.closeAllTabs());
        }
      }

      initColorTab() {
        this.colorItems.forEach((item) => {
          item.addEventListener('click', () => {
            // 如果已经是 active，则不做任何操作
            if (item.classList.contains('active')) return;

            // 移除所有 active
            this.colorItems.forEach((c) => c.classList.remove('active'));
            // 添加当前 active
            item.classList.add('active');

            // 读取颜色变量
            const color = item.style.getPropertyValue('--color');
            const index = item.getAttribute('data-index');

            // 设置图标颜色
            this.colorIcon.style.setProperty('--color_icon', color);

            // 更新当前激活的颜色索引
            this.activeColorIndex = index;

            // 显示对应的颜色图片
            this.showColorImage(index);
          });
        });
      }

      showColorImage(index) {
        const colorTabBox = this.querySelector('.yg-color-tab-box');
        if (!colorTabBox) return;

        const colorImages = colorTabBox.querySelectorAll('.yg-color-image');
        if (!colorImages.length) return;

        // 隐藏所有颜色图片
        colorImages.forEach((img) => {
          img.style.display = 'none';
        });

        // 显示对应索引的图片
        const targetImage = colorTabBox.querySelector(`.yg-color-image[data-index="${index}"]`);
        if (targetImage) {
          targetImage.style.display = 'block';
        }
      }

      initMeasurements() {
        this.tabBoxes.forEach((tabBox) => {
          requestAnimationFrame(() => {
            const rect = tabBox.getBoundingClientRect();
            const w = Math.ceil(rect.width);
            const h = Math.ceil(rect.height);

            // 写入 CSS 变量
            tabBox.style.setProperty('--initial-max-width', w + 'px');
            tabBox.style.setProperty('--initial-max-height', h + 'px');
          });
        });
      }

      selectTab(index) {
        const prevIndex = this.currentIndex;
        this.currentIndex = index;

        this.tabButtons.classList.add('active');
        this.crossButton.classList.add('active');

        if (this.tabBoxes[index].classList.contains('active')) {
          return;
        }

        if (prevIndex == 0 && index == 0) {
          this.tabBoxes[index].classList.add('active');

          setTimeout(() => {
            this.tabTexts[index].classList.add('active');
          }, 500);
        }

        if (!this.tabBoxes[index].classList.contains('yg-tab_color')) {
          this.colorImages.style.opacity = '';
        }

        // 先处理退出动画
        this.handleImageExit(prevIndex);

        // 延迟处理文本和盒子的动画，确保图片动画有足够时间显示
        setTimeout(() => {
          this.tabBoxes.forEach((tabBox) => {
            tabBox.classList.remove('active');
          });
          this.tabTexts.forEach((tabText) => {
            tabText.classList.remove('active');
          });

          this.tabBoxes[index].classList.add('active');

          setTimeout(() => {
            this.tabTexts[index].classList.add('active');
            // 处理进入动画
            this.handleImageEnter(index);
          }, 500);
        }, 400); // 等待图片离开动画完成后再更新盒子状态

        this.prevButton.classList.remove('disable');
        this.nextButton.classList.remove('disable');
        if (index == 0) {
          this.prevButton.classList.add('disable');
        }

        if (index + 1 == this.tabBoxes.length) {
          this.nextButton.classList.add('disable');
        }
      }

      // 处理图片退出动画
      handleImageExit(index) {
        if (this.tabImages[index]) {
          const image = this.tabImages[index];
          // 移除 entering 状态并添加 leaving 状态
          image.classList.remove('entering');
          image.classList.add('leaving');

          // 在动画结束后清除 leaving 状态
          setTimeout(() => {
            image.classList.remove('leaving');
          }, 400);
        }
      }

      // 处理图片进入动画
      handleImageEnter(index) {
        if (this.tabImages[index]) {
          const image = this.tabImages[index];
          // 确保清除之前的动画状态
          image.classList.remove('leaving');
          // 强制重排
          image.offsetHeight;
          // 从右侧进入，并保持 entering 状态
          image.classList.add('entering');
        }
      }

      previousTab() {
        if (this.currentIndex > 0) {
          this.selectTab(this.currentIndex - 1);
        }
      }

      nextTab() {
        if (this.currentIndex < this.tabBoxes.length - 1) {
          this.selectTab(this.currentIndex + 1);
        }
      }

      // 新增关闭所有选项卡的方法
      closeAllTabs() {
        if (this.tabImages[this.currentIndex] && this.currentIndex != 0) {
          const currentImage = this.tabImages[this.currentIndex];
          currentImage.classList.remove('entering');
          currentImage.classList.add('leaving');

          // 在动画结束后清除 leaving 状态
          setTimeout(() => {
            currentImage.classList.remove('leaving');
          }, 400);
        }

        // 延迟处理文本和盒子的动画
        setTimeout(() => {
          this.tabTexts[this.currentIndex].classList.remove('active');

          this.tabBoxes[this.currentIndex].classList.remove('active');

          // 隐藏 tab buttons 和 cross button
          this.tabButtons.classList.remove('active');
          this.crossButton.classList.remove('active');

          this.colorImages.style.opacity = '1';

          // 重置当前索引
          this.currentIndex = 0;
        }, 400);
      }
    }
    if (!window.customElements.get('yg-product-show-tab')) {
      window.customElements.define('yg-product-show-tab', YGProductShowTab);
    }

    class YGProductShowTabMobile extends HTMLElement {
      constructor() {
        super();
        this.tabBoxes = [];
        this.currentIndex = 0;
        this.activeColorIndex = 1;
        this.swiperInstance = null;
        this.isSwiperInitialized = false; // 标记Swiper是否已初始化
        this.isTransitioning = false; // 标记是否正在过渡
      }

      connectedCallback() {
        this.tabBoxes = this.querySelectorAll('.yg-tab-box');
        this.crossButton = this.querySelector('.yg-cross');
        this.swiperWrapper = this.querySelector('.yg-tabs-box .swiper-wrapper');
        this.ygTabsBox = this.querySelector('.yg-tabs-box');
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');
        this.defaultImage = this.querySelector('.yg-default-image');
        this.imagesSwiperElement = this.querySelector('.yg-tabs-box-images');

        // 初始化时隐藏导航按钮
        this.hideNavigationButtons();
        this.hideCrossButton();

        // 初始化时添加样式
        this.addWrapperStyles();

        this.init();
        this.initCloseButton();
      }

      init() {
        this.tabBoxes.forEach((tabBox, index) => {
          tabBox.addEventListener('click', () => this.selectTab(index));
        });
      }

      // 添加初始样式
      addWrapperStyles() {
        // 给 yg-tabs-box 添加样式
        if (this.ygTabsBox) {
          this.ygTabsBox.style.overflow = 'auto';
          this.ygTabsBox.style.width = '100vw';
          this.ygTabsBox.style.marginInline = '-20px';
          this.ygTabsBox.style.scrollbarWidth = 'none'; /* Firefox */
          this.ygTabsBox.style.msOverflowStyle = 'none'; /* IE/Edge */
        }

        // 给 swiper-wrapper 添加样式
        if (this.swiperWrapper) {
          this.swiperWrapper.style.gap = '12px';
          this.swiperWrapper.style.paddingInline = '20px';

          // 隐藏滚动条（WebKit 浏览器）
          const style = document.createElement('style');
          const sectionId = this.closest('.shopify-section')?.id;
          if (sectionId) {
            style.textContent = `
            #${sectionId} .swiper-wrapper::-webkit-scrollbar {
              display: none;
            }
          `;
            this.appendChild(style);
          }
        }
      }

      // 移除初始样式
      removeWrapperStyles() {
        // 移除 yg-tabs-box 样式
        if (this.ygTabsBox) {
          this.ygTabsBox.style.overflow = '';
          this.ygTabsBox.style.width = '';
          this.ygTabsBox.style.marginInline = '';
          this.ygTabsBox.style.scrollbarWidth = '';
          this.ygTabsBox.style.msOverflowStyle = '';
        }

        // 移除 swiper-wrapper 样式
        if (this.swiperWrapper) {
          this.swiperWrapper.style.gap = '';
          this.swiperWrapper.style.paddingInline = '';
        }
      }

      initCloseButton() {
        if (this.crossButton) {
          this.crossButton.addEventListener('click', () => this.closeAllTabs());
        }
      }

      // 隐藏导航按钮
      hideNavigationButtons() {
        if (this.prevButton) {
          this.prevButton.style.display = 'none';
        }
        if (this.nextButton) {
          this.nextButton.style.display = 'none';
        }
      }

      // 显示导航按钮
      showNavigationButtons() {
        if (this.prevButton) {
          this.prevButton.style.display = '';
        }
        if (this.nextButton) {
          this.nextButton.style.display = '';
        }
      }

      // 显示cross按钮
      showCrossButton() {
        if (this.crossButton) {
          this.crossButton.classList.add('active');
        }
      }

      // 隐藏cross按钮
      hideCrossButton() {
        if (this.crossButton) {
          this.crossButton.classList.remove('active');
        }
      }

      selectTab(index) {
        // 如果Swiper还未初始化，则先激活所有tab，再初始化Swiper
        if (!this.isSwiperInitialized) {
          // 激活所有tab box
          this.tabBoxes.forEach((tabBox) => {
            tabBox.classList.add('active');
          });

          this.defaultImage.classList.remove('active');

          // 移除初始样式
          this.removeWrapperStyles();

          // 延迟初始化Swiper，确保所有tab都已激活
          setTimeout(() => {
            this.initSwiper();
            this.isSwiperInitialized = true;

            // 显示导航按钮
            this.showNavigationButtons();
            this.showCrossButton();

            // 初始化后，将当前选中的tab滑动到视图中心
            if (this.swiperInstance) {
              this.swiperInstance.slideTo(index, 700);
            }
          }, 100);
        } else {
          // 如果Swiper已初始化，直接滑动到对应slide
          if (this.swiperInstance) {
            this.swiperInstance.slideTo(index, 700);
          }
        }
      }

      closeAllTabs() {
        // 移除所有tab的active类
        this.tabBoxes.forEach((tabBox) => {
          tabBox.classList.remove('active');
        });

        // 隐藏导航按钮
        this.hideNavigationButtons();
        this.hideCrossButton();
        this.defaultImage.classList.add('active');

        // 销毁Swiper实例
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
        if (this.imagesSwiperInstance) {
          this.imagesSwiperInstance.destroy(true, true);
          this.imagesSwiperInstance = null;
        }

        this.isSwiperInitialized = false;

        if (this.imagesSwiperElement) {
          this.imagesSwiperElement.classList.remove('is-interactive');
        }

        // 重新添加初始样式
        this.addWrapperStyles();

        // 重置当前索引
        this.currentIndex = 0;
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }

        if (this.imagesSwiperInstance) {
          this.imagesSwiperInstance.destroy(true, true);
          this.imagesSwiperInstance = null;
        }
      }

      initSwiper() {
        const swiperElement = this.querySelector('.yg-tabs-box');
        const imagesSwiperElement = this.querySelector('.yg-tabs-box-images');
        if (!swiperElement) return;

        // 确保 Swiper 库已加载
        if (typeof Swiper !== 'undefined') {
          this.swiperInstance = new Swiper(swiperElement, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev'),
            },
            on: {
              // 初始化完成后更新 slide 位置
              init: () => {
                setTimeout(() => {
                  if (this.swiperInstance) {
                    this.swiperInstance.update();
                  }
                  const activeIndex = this.swiperInstance.activeIndex;

                  // 同步images swiper
                  if (this.imagesSwiperInstance) {
                    this.imagesSwiperInstance.slideTo(activeIndex, 0);
                  }
                }, 500);
              },

              // 在任何过渡开始时隐藏按钮（包括手动滑动）
              transitionStart: () => {
                this.isTransitioning = true;
                this.hideNavigationButtons();
              },

              // 在任何过渡结束时显示按钮
              transitionEnd: () => {
                this.isTransitioning = false;
                this.showNavigationButtons();
              },

              // 监听触摸开始事件
              touchStart: () => {
                if (!this.isTransitioning) {
                  // this.hideNavigationButtons();
                }
              },

              // 监听触摸结束事件
              touchEnd: () => {
                if (!this.isTransitioning) {
                  // 短暂延迟后显示按钮，确保不会立即显示
                  setTimeout(() => {
                    if (!this.isTransitioning) {
                      this.showNavigationButtons();
                    }
                  }, 100);
                }
              },

              // 当tabs swiper滑动结束时，同步images swiper并激活对应的tab
              slideChangeTransitionStart: () => {
                const activeIndex = this.swiperInstance.activeIndex;

                // 激活对应的tab文本
                this.activateTabText(activeIndex);

                // 同步images swiper
                if (this.imagesSwiperInstance) {
                  this.imagesSwiperInstance.slideTo(activeIndex, 300);
                }
              },
            },
          });

          this.imagesSwiperInstance = new Swiper(imagesSwiperElement, {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 12,
            allowTouchMove: true,
            threshold: 10,
            touchRatio: 1,
            on: {
              transitionStart: () => {
                this.isTransitioning = true;
                this.hideNavigationButtons();
              },
              transitionEnd: () => {
                this.isTransitioning = false;
                this.showNavigationButtons();
              },
              // 当images swiper滑动时，同步tabs swiper
              slideChangeTransitionStart: () => {
                const activeIndex = this.imagesSwiperInstance.activeIndex;

                if (this.swiperInstance && this.swiperInstance.activeIndex !== activeIndex) {
                  this.swiperInstance.slideTo(activeIndex, 700);
                }

                this.activateTabText(activeIndex);
              },
            },
          });

          if (this.imagesSwiperElement) {
            this.imagesSwiperElement.classList.add('is-interactive');
          }

          // 初始化颜色选择器功能
          this.initColorSelectors();
        }
      }

      // 初始化颜色选择器
      initColorSelectors() {
        // 为每个颜色选择器tab添加事件监听
        const colorTabs = this.querySelectorAll('.yg-color-tab-box');
        colorTabs.forEach((tabBox, tabIndex) => {
          const colorItems = tabBox.querySelectorAll('.yg-color-item');
          const colorTabBox = tabBox; // 当前颜色tab容器

          colorItems.forEach((item, itemIndex) => {
            item.addEventListener('click', () => {
              // 如果已经是 active，则不做任何操作
              if (item.classList.contains('active')) return;

              // 移除所有 active
              colorItems.forEach((c) => c.classList.remove('active'));
              // 添加当前 active
              item.classList.add('active');

              // 读取颜色变量
              const color = item.style.getPropertyValue('--color');
              const index = item.getAttribute('data-index');

              // 设置图标颜色
              const tabIcon = colorTabBox.querySelector('.yg-tab-icon');
              if (tabIcon) {
                tabIcon.style.setProperty('--color_icon', color);
              }

              // 更新当前激活的颜色索引
              this.activeColorIndex = index;

              // 显示对应的颜色图片
              this.showColorImage(index);
            });
          });
        });
      }

      // 显示对应索引的颜色图片
      showColorImage(index) {
        const colorImages = this.querySelectorAll('.yg-color-image');
        if (!colorImages.length) return;

        // 隐藏所有颜色图片
        colorImages.forEach((img) => {
          img.classList.remove('active');
        });

        // 显示对应索引的图片
        const targetImage = this.querySelectorAll(`.yg-color-image[data-index="${index}"]`);
        if (targetImage) {
          targetImage.forEach((img) => {
            img.classList.add('active');
          });
        }
      }

      // 激活指定索引的tab文本
      activateTabText(index) {
        // 获取所有tab文本元素
        const tabTexts = this.querySelectorAll('.yg-tab-text');

        // 隐藏所有文本
        tabTexts.forEach((text) => {
          text.classList.remove('active');
        });

        // 显示当前索引的文本
        if (tabTexts[index]) {
          tabTexts[index].classList.add('active');
        }
      }
    }

    if (!window.customElements.get('yg-product-show-tab-mobile')) {
      window.customElements.define('yg-product-show-tab-mobile', YGProductShowTabMobile);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
